import React, {Component} from 'react';
import queryString from 'query-string'
import {publish} from "../../Events/events";
import {FocusMessengerActiveGroup, FocusOrder} from "../../Events/topics";
import {shallowEqualObjects} from "shallow-equal";

export default class UrlParams extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();

        const parsedParams = this.parseLocationParams(props.location);

        this.useParamsInitTimeout = setTimeout(() => {
            if (props.orders && props.assignedGroups && props.messengers) {
                this.useParams(parsedParams, props.orders, props.assignedGroups, props.messengers);
                this.useParamsInitTimeout = null;
                this.previousLocation = props.location;
            }
        }, 500);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    handleClickOutside() {
        if (this.focusedOriginalOrderId) {
            this.onFocusedOriginalOrderIdChanged(null, this.props.orders);

            this.focusedOriginalOrderId = null;
        }
    }

    parseLocationParams(location) {
        const parsedSearch = queryString.parse(location.search);
        const parsedHash = queryString.parse(location.hash);

        return {...parsedSearch, ...parsedHash}
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const parsedParams = this.parseLocationParams(nextProps.location);
        const previousParsedParams = this.previousLocation ? this.parseLocationParams(this.previousLocation) : undefined;

        if (nextProps.orders && nextProps.assignedGroups && nextProps.messengers && !shallowEqualObjects(parsedParams, previousParsedParams)) {
            if (this.useParamsInitTimeout) {
                clearTimeout(this.useParamsInitTimeout);
                this.useParamsInitTimeout = null;
            }

            this.useParams(parsedParams, nextProps.orders, nextProps.assignedGroups, nextProps.messengers);

            this.previousLocation = nextProps.location;
        }
    }

    useParams(params, orders, groups, messengers) {
        if (params.focusedOriginalOrderId !== this.focusedOriginalOrderId) {
            this.onFocusedOriginalOrderIdChanged(params.focusedOriginalOrderId, orders);
            this.focusedOriginalOrderId = params.focusedOriginalOrderId;
        }

        if (params.focusedMessengerPhoneNumber !== this.focusedMessengerPhoneNumber) {
            this.onFocusedMessengerPhoneNumberChanged(params.focusedMessengerPhoneNumber, messengers, groups);
            this.focusedMessengerPhoneNumber = params.focusedMessengerPhoneNumber;
        }
    }

    onFocusedOriginalOrderIdChanged(originalOrderId, orders) {
        if (!originalOrderId) {
            publish(FocusOrder, {orderId: null});
            return;
        }

        const foundOrder = orders.find(o => o.originalId === originalOrderId);

        if (foundOrder)
            publish(FocusOrder, {orderId: foundOrder.id});
        else
            publish(FocusOrder, {orderId: null});
    }

    onFocusedMessengerPhoneNumberChanged(messengerPhoneNumber, messengers, groups) {
        if (!messengerPhoneNumber) {
            publish(FocusMessengerActiveGroup, {groupId: null});
            return;
        }

        const foundUser = messengers.find(m => m.phoneNumber === messengerPhoneNumber);

        if (!foundUser) {
            publish(FocusMessengerActiveGroup, {groupId: null});
            return;
        }

        const foundGroup = groups.find(g => g.messenger_id === foundUser.id);

        if (foundGroup)
            publish(FocusMessengerActiveGroup, {groupId: foundGroup.id});
        else
            publish(FocusMessengerActiveGroup, {groupId: null});
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return false;
    }

    render() {
        return <div ref={this.wrapperRef}/>;
    }
}